import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { UserPlus, UserCheck } from 'lucide-react';
import { toast } from 'sonner';

export function FollowButton({ targetType, targetId, showCount = true, className = '' }) {
  const [following, setFollowing] = useState(false);
  const [followers, setFollowers] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!targetId) return;
    api.get(`/follow/status/${targetType}/${targetId}`)
      .then((r) => { setFollowing(r.data.following); setFollowers(r.data.followers); })
      .catch(() => {});
  }, [targetType, targetId]);

  const toggle = async () => {
    setBusy(true);
    try {
      const r = following
        ? await api.delete(`/follow/${targetType}/${targetId}`)
        : await api.post('/follow', { target_type: targetType, target_id: targetId });
      setFollowing(r.data.following);
      setFollowers(r.data.followers);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Could not update follow');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      onClick={toggle}
      disabled={busy}
      size="sm"
      className={
        (following
          ? 'rounded-full border border-white/15 bg-white/10 text-white hover:bg-white/15 '
          : 'rounded-full bg-[#F6B24A] text-[#1A1208] hover:bg-[#FFC065] font-semibold ') + className
      }
      data-testid={`follow-button-${targetType}-${targetId}`}
    >
      {following ? <UserCheck className="mr-1.5 h-3.5 w-3.5" /> : <UserPlus className="mr-1.5 h-3.5 w-3.5" />}
      {following ? 'Following' : 'Follow'}
      {showCount && followers !== null && <span className="ml-1.5 opacity-70">· {followers}</span>}
    </Button>
  );
}
